/**
 * Header beim Scrollen: .is-scrolled, sobald die Seite nicht mehr ganz oben ist (dunkle Glasleiste).
 * Der Header bleibt beim Onepager immer sichtbar – die Anker-Navigation muss jederzeit erreichbar sein.
 */
import { qs } from '../utils/dom.js';

export function init() {
	const header = qs('[data-pa-header]');
	if (!header) return;

	let ticking = false;
	const update = () => {
		header.classList.toggle('is-scrolled', window.scrollY > 8);
		ticking = false;
	};
	window.addEventListener('scroll', () => {
		if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
	}, { passive: true });
	update();
}
